module.exports = __webpack_public_path__ + "media/images/icon-nav-device-bdf518f18a4da3dd3e248272dc1d08ec.png";